<template>
  <div class="sidebar-wrapper">
    <div class="sidebar">
      <router-link to="/app/dashboard">
        <div class="logo-holder">
          <div class="logo"></div>
        </div>
      </router-link>
      <router-link to="/app/dashboard">
        <div 
          class="nav-item" 
          :class="{ 'nav-active': getNavItemClass('dashboard') }">
          <div class="icon" :class="getNavItemClass('dashboard') ? 'dashboard-icon-white' : 'dashboard-icon-grey'"></div>
          <span>Dashboard</span>
        </div>
      </router-link>
      <router-link to="/app/content">
        <div 
          class="nav-item" 
          :class="{ 'nav-active': getNavItemClass('content') }">
          <div class="icon" :class="getNavItemClass('content') ? 'content-icon-white' : 'content-icon-grey'"></div>
          <span>Content gen</span>
        </div>
      </router-link>
      <router-link to="/app/users">
        <div 
          class="nav-item" 
          :class="{ 'nav-active': getNavItemClass('users') }">
          <div class="icon" :class="getNavItemClass('users') ? 'users-icon-white' : 'users-icon-grey'"></div>
          <span>Users</span>
        </div>
      </router-link>
      <router-link to="/app/exercises">
        <div 
          class="nav-item" 
          :class="{ 'nav-active': getNavItemClass('exercises') }">
          <div class="icon" :class="getNavItemClass('exercises') ? 'exercises-icon-white' : 'exercises-icon-grey'"></div>
          <span>Exercises</span>
        </div>
      </router-link>
      <router-link to="/app/workouts">
        <div 
          class="nav-item" 
          :class="{ 'nav-active': getNavItemClass('workouts') }">
          <div class="icon" :class="getNavItemClass('workouts') ? 'workouts-icon-white' : 'workouts-icon-grey'"></div>
          <span>Workouts</span>
        </div>
      </router-link>
      <router-link to="/app/challenges">
        <div 
          class="nav-item" 
          :class="{ 'nav-active': getNavItemClass('challenges') }">
          <div class="icon" :class="getNavItemClass('challenges') ? 'challenges-icon-white' : 'challenges-icon-grey'"></div>
          <span>Challenges</span>
        </div>
      </router-link>
      <router-link to="/app/brands">
        <div 
          class="nav-item" 
          :class="{ 'nav-active': getNavItemClass('brands') }">
          <div class="icon" :class="getNavItemClass('brands') ? 'brands-icon-white' : 'brands-icon-grey'"></div>
          <span>Brands</span>
        </div>
      </router-link>
      <router-link to="/app/tags">
        <div 
          class="nav-item" 
          :class="{ 'nav-active': getNavItemClass('tags') }">
          <div class="icon" :class="getNavItemClass('tags') ? 'tags-icon-white' : 'tags-icon-grey'"></div>
          <span>Tags</span>
        </div>
      </router-link>
      <router-link to="/app/content_editor">
        <div 
          class="nav-item" 
          :class="{ 'nav-active': getNavItemClass('editor') }">
          <div class="icon" :class="getNavItemClass('editor') ? 'editor-icon-white' : 'editor-icon-grey'"></div>
          <span>Content editor</span>
        </div>
      </router-link>
      <router-link to="/app/promotional">
        <div 
          class="nav-item" 
          :class="{ 'nav-active': getNavItemClass('promotional') }">
          <div class="icon" :class="getNavItemClass('promotional') ? 'promotional-icon-white' : 'promotional-icon-grey'"></div>
          <span>Ads Manager</span>
        </div>
      </router-link>
      <router-link to="/app/feedback">
        <div 
          class="nav-item" 
          :class="{ 'nav-active': getNavItemClass('feedback') }">
          <div class="icon" :class="getNavItemClass('feedback') ? 'feedback-icon-white' : 'feedback-icon-grey'"></div>
          <span>Feedback</span>
        </div>
      </router-link>
      <router-link to="/app/reports">
        <div 
          class="nav-item" 
          :class="{ 'nav-active': getNavItemClass('reports') }">
          <div class="icon" :class="getNavItemClass('reports') ? 'reports-icon-white' : 'reports-icon-grey'"></div>
          <span>Reports</span>
        </div>
      </router-link>
      <router-link to="/app/settings">
        <div 
          class="nav-item" 
          :class="{ 'nav-active': getNavItemClass('settings') }">
          <div class="icon" :class="getNavItemClass('settings') ? 'reports-icon-white' : 'reports-icon-grey'"></div>
          <span>Settings</span>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Sidebar',

  methods: {
    getNavItemClass(route) {
      const validRouteNames = {
        'dashboard': ['Dashboard'],
        'content': ['Content'],
        'users': ['Users'],
        'exercises': ['Exercises'],
        'workouts': ['Workouts'],
        'challenges': ['Challenges'],
        'brands': ['Brands'],
        'tags': ['Tags'],
        'editor': ['ContentEditor', 'ContentEditorDetails'],
        'promotional': ['Promotional'],
        'feedback': ['Feedback'],
        'reports': ['Reports'],
        'settings': ['Settings'],
      };

      return validRouteNames[route].includes(this.$route.name);
    },

    expandMenu() {
      this.$store.commit('expandMenu');
    },
  },

  computed: {
    menuExpanded() {
      return this.$store.state.menuExpanded;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";

.sidebar-wrapper {
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  width: $sidebar-width;
  background: $sec0;
  z-index: 2;

  .sidebar {
    z-index: 2;
    width: 100%;
    background: $sec0;
    a {
      display: block;
      text-decoration: none;
    }

    .logo-holder {
      width: 100%;
      background: rgb(6,109,205);
      background: linear-gradient(90deg, rgba(6,109,205,1) 0%, rgba(0,58,112,1) 100%);
      box-sizing: border-box;
      height: 100px;
      overflow: hidden;
      background-position: center;
      margin-bottom: $spacing-base;
      .logo {
        background-image: url(~@/assets/Wotive-Logo.svg);
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        width: 100%;
        height: 100%;
      }
    }
    .nav-item {
      overflow: hidden;
      width: 100%;
      color: $sec3;
      position: relative;
      display: flex;
      padding-top: $spacing-base;
      padding-bottom: $spacing-base;
      font-family: 'Rubik', sans-serif;
      text-decoration: none;
      
      &:hover {
        color: #FFF;
        cursor: pointer;
      }

      span {
        text-decoration: none;
        font-weight: 500;
        font-size: 12px;
        margin-left: $spacing-base;
        line-height: 20px;
        text-transform: uppercase;
      }

      .icon {
        background-size: cover;
        background-repeat: no-repeat;
        width: 18px;
        height: 18px;
        margin-left: $spacing-base;
        color: $sec3;
      }

      .dashboard-icon-grey {
        background-image: url(~@/assets/nav_icons/dashboard.svg);
      }
      .dashboard-icon-white {
        background-image: url(~@/assets/nav_icons/dashboard-white.svg);
      }
      .content-icon-grey {
        background-image: url(~@/assets/nav_icons/content_gen.svg);
      }
      .content-icon-white {
        background-image: url(~@/assets/nav_icons/content_gen-white.svg);
      }
      .users-icon-grey {
        background-image: url(~@/assets/nav_icons/users.svg);
      }
      .users-icon-white {
        background-image: url(~@/assets/nav_icons/users-white.svg);
      }
      .exercises-icon-grey {
        background-image: url(~@/assets/nav_icons/exercises.svg);
      }
      .exercises-icon-white {
        background-image: url(~@/assets/nav_icons/exercises-white.svg);
      }
      .workouts-icon-grey {
        background-image: url(~@/assets/nav_icons/workout.svg);
      }
      .workouts-icon-white {
        background-image: url(~@/assets/nav_icons/workout-white.svg);
      }
      .challenges-icon-grey {
        background-image: url(~@/assets/nav_icons/challenges.svg);
      }
      .challenges-icon-white {
        background-image: url(~@/assets/nav_icons/challenges-white.svg);
      }
      .brands-icon-grey {
        background-image: url(~@/assets/nav_icons/brands.svg);
      }
      .brands-icon-white {
        background-image: url(~@/assets/nav_icons/brands-white.svg);
      }
      .tags-icon-grey {
        background-image: url(~@/assets/nav_icons/tags.svg);
      }
      .tags-icon-white {
        background-image: url(~@/assets/nav_icons/tags-white.svg);
      }
      .editor-icon-grey {
        background-image: url(~@/assets/nav_icons/content_editor.svg);
      }
      .editor-icon-white {
        background-image: url(~@/assets/nav_icons/content_editor-white.svg);
      }
      .promotional-icon-grey {
        background-image: url(~@/assets/nav_icons/promotions.svg);
      }
      .promotional-icon-white {
        background-image: url(~@/assets/nav_icons/promotions-white.svg);
      }
      .feedback-icon-grey {
        background-image: url(~@/assets/nav_icons/feedback.svg);
      }
      .feedback-icon-white {
        background-image: url(~@/assets/nav_icons/feedback-white.svg);
      }
      .reports-icon-grey {
        background-image: url(~@/assets/nav_icons/reports.svg);
      }
      .reports-icon-white {
        background-image: url(~@/assets/nav_icons/reports-white.svg);
      }
    }
    .nav-active {
      color: #FFF;
    }
  }
}
</style>